var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDaxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68AE",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.746 12.72a2.136 2.136 0 0 0-3.03-.17 2.172 2.172 0 0 0-.17 3.052l11.13 12.532-11.114 12.247c-.8.881-.739 2.248.136 3.053a2.136 2.136 0 0 0 3.032-.137l12.424-13.689 1.309-1.442-1.293-1.456-12.424-13.99Zm21.63 3.065a2.172 2.172 0 0 0-.008-3.056 2.135 2.135 0 0 0-3.035.008l-6.478 6.555-1.514 1.532 3.043 3.048 1.514-1.532 6.477-6.555Zm-6.533 18.067-1.567-1.476-2.933 3.156 1.567 1.476 6.478 6.103c.865.816 2.223.77 3.033-.101a2.172 2.172 0 0 0-.1-3.054l-6.478-6.104Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxLogo);
export default __webpack_public_path__ + "static/media/dax-logo.276f71ba924695743f2f928212215908.svg";
export { ForwardRef as ReactComponent };